import type { KlarnaConfig } from '#types/config/components/klarna'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    disclaimerText: 'text-sm c-grey-20',
    headingLogo: 'mb-4',
    introText: 'mb-6 text-sm md:(mb-8 text-md)',
    logo: 'ml-1 <md:(h-2.5 w-a)'
  },
  imageHeight: 12,
  imageWidth: 54,
  installments: {
    'default': 4,
    'en-gb': 3,
  },
  logo: {
    pdpDialog: 'klarna'
  },
  maxThreshold: 1000,
  minThreshold: 35,
  termsUrl: {
    'default': 'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/{locale}/paylaterin3',
    'en-us': 'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx'
  },
  showInstallmentsInfo: true,
} satisfies RecursivePartial<KlarnaConfig>
